import { render, staticRenderFns } from "./VehicleProvisionSummaryView.vue?vue&type=template&id=5bcc348a&scoped=true&"
import script from "./VehicleProvisionSummaryView.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionSummaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc348a",
  null
  
)

export default component.exports
import {QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QInnerLoading,QSpinnerGears}, component.options.components || {})
